module.exports = __webpack_public_path__ + "img/img77.f6436f11.svg";